import Header from "./Header";
import "./App.scss";
import "./plugins.scss";
import { Gallery } from "react-grid-gallery";
import { videos } from "./videos";
import { useState } from "react";
import i18n from "./i18n";
import { I18nextProvider, useTranslation } from "react-i18next";
import Accordion from "./Accordion";
import { toast, ToastContainer } from "react-toastify";
import Footer from "./Footer";
import VideoModal from "./VideoModal";
import AccordionVideo from "./AccordionVideo";

function App() {
  const [maxHeightGal, setMaxHeightGal] = useState(700);
  const [hideShowMore, setHideShowMore] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    message: "",
    email: "",
  });
  const { t } = useTranslation();

  const images = videos.map((video) => ({
    src: video.thumbnail,
    width: video.width,
    height: video.height,
    customOverlay: (
      <div className="custom-overlay__caption">
        <div>{t(video.title)}</div>
        <div className="play-button">▶</div>
      </div>
    ),
  }));

  const onClickShowMore = () => {
    const newVal = maxHeightGal + 1200;
    setMaxHeightGal(newVal);

    setTimeout(() => {
      const galHeight = document.querySelector(".gallery-css").offsetHeight;
      if (newVal !== galHeight) {
        setHideShowMore(true);
      }
    }, 100);
  };

  const onClickSubmit = async () => {
    if (!form.email || !form.firstName || !form.lastName || !form.message) {
      toast.warn(t("please_fill"));
    } else {
      try {
        const response = await fetch("https://rgdrone.com/Main/ContactUs", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        });

        if (response.ok) {
          toast.success(t("message_sent"));
          setForm({
            firstName: "",
            lastName: "",
            phone: "",
            message: "",
            email: "",
          });
        } else {
          toast.error(t("error_sending"));
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error(t("error_sending"));
      }
    }
  };

  return (
    <I18nextProvider i18n={i18n}>
      <div className="app">
        <Header />
        <div className="main" id="home">
          <iframe
            style={{
              border: 0,
              pointerEvents: "none",
            }}
            src="https://www.youtube.com/embed/qO2W7h-23ZI?si=nJJtJJ1nTwxV4wCT&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&autoplay=1&mute=1&loop=1&playlist=qO2W7h-23ZI"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>

        <section className="text-photo" id="about">
          <div className="text-photo-1">
            <div className="text-photo-1-bg"></div>
            <div className="text-photo-1-img">
              <img src="/driver.jpg" alt="1" />
            </div>
          </div>
          <div className="text-photo-2">
            <div className="text-photo-title">{t("who_we_are")}</div>
            <div style={{ marginBlock: 10, fontWeight: 600 }}>
              {t("our_vision")}
            </div>
            <div>{t("our_vision_1")}</div>
            <div style={{ marginBlock: 10, fontWeight: 600 }}>
              {t("our_story")}
            </div>
            <div>{t("our_story_1")}</div>
          </div>
        </section>
        <section className="accordion" id="services">
          <Accordion title={t("what_we_1")}>
            <div>{t("what_we_11")}</div>
            <div>{t("what_we_12")}</div>
            <div>{t("what_we_13")}</div>
            <ol>
              <li>{t("what_we_131")}</li>
              <li>{t("what_we_132")}</li>
              <li>{t("what_we_133")}</li>
              <li>{t("what_we_134")}</li>
            </ol>
            <div>{t("what_we_14")}</div>
            <ol style={{ listStyle: "none" }}>
              <li>{t("what_we_141")}</li>
            </ol>
            <div>{t("what_we_15")}</div>
            <ol>
              <li>{t("what_we_151")}</li>
              <li>{t("what_we_152")}</li>
              <li>{t("what_we_153")}</li>
            </ol>
            <AccordionVideo
              videos={[{ id: "aA41F_OgHgE" }]}
              onVideoSelect={setSelectedVideo}
            />
          </Accordion>
          <Accordion title={t("what_we_2")}>
            <div>{t("what_we_21")}</div>
            <div>{t("what_we_22")}</div>
            <ol>
              <li>{t("what_we_221")}</li>
              <li>{t("what_we_222")}</li>
              <li>{t("what_we_223")}</li>
            </ol>
            <div>{t("what_we_23")}</div>
            <ol style={{ listStyle: "none" }}>
              <li>{t("what_we_231")}</li>
            </ol>
            <div>{t("what_we_24")}</div>
            <ol>
              <li>{t("what_we_241")}</li>
              <li>{t("what_we_242")}</li>
              <li>{t("what_we_243")}</li>
            </ol>
            <AccordionVideo
              videos={[{ id: "gzNCeSxHx9Q" }]}
              onVideoSelect={setSelectedVideo}
            />
          </Accordion>
          <Accordion title={t("what_we_3")}>
            <div>{t("what_we_31")}</div>
            <div>{t("what_we_32")}</div>
            <div>{t("what_we_33")}</div>
            <ol>
              <li>{t("what_we_331")}</li>
              <li>{t("what_we_332")}</li>
              <li>{t("what_we_333")}</li>
            </ol>
            <div>{t("what_we_34")}</div>
            <ol style={{ listStyle: "none" }}>
              <li>{t("what_we_341")}</li>
            </ol>
            <div>{t("what_we_35")}</div>
            <ol>
              <li>{t("what_we_351")}</li>
              <li>{t("what_we_352")}</li>
              <li>{t("what_we_353")}</li>
            </ol>
            <AccordionVideo
              videos={[{ id: "RIu-iotACuU" }]}
              onVideoSelect={setSelectedVideo}
            />
          </Accordion>
          <Accordion title={t("what_we_4")}>
            <div>{t("what_we_41")}</div>
            <div>{t("what_we_42")}</div>
            <ol>
              <li>{t("what_we_421")}</li>
              <li>{t("what_we_422")}</li>
              <li>{t("what_we_423")}</li>
            </ol>
            <div>{t("what_we_43")}</div>
            <ol style={{ listStyle: "none" }}>
              <li>{t("what_we_431")}</li>
            </ol>
            <div>{t("what_we_44")}</div>
            <ol>
              <li>{t("what_we_441")}</li>
              <li>{t("what_we_442")}</li>
              <li>{t("what_we_443")}</li>
            </ol>
            <AccordionVideo
              videos={[{ id: "b3b3uYyEtME" }]}
              onVideoSelect={setSelectedVideo}
            />
          </Accordion>
          <Accordion title={t("what_we_5")}>
            <div>{t("what_we_51")}</div>
            <div>{t("what_we_52")}</div>
            <ol>
              <li>{t("what_we_521")}</li>
              <li>{t("what_we_522")}</li>
              <li>{t("what_we_523")}</li>
            </ol>
            <div>{t("what_we_53")}</div>
            <ol style={{ listStyle: "none" }}>
              <li>{t("what_we_531")}</li>
            </ol>
            <div>{t("what_we_54")}</div>
            <ol>
              <li>{t("what_we_541")}</li>
              <li>{t("what_we_542")}</li>
              <li>{t("what_we_543")}</li>
            </ol>
            <AccordionVideo
              videos={[{ id: "njahgbnsoqo" }]}
              onVideoSelect={setSelectedVideo}
            />
          </Accordion>
        </section>
        <section className="gallery" id="gallery">
          <div className="gallery-title">{t("port_vid")}</div>
          <div
            className="gallery-css"
            style={{ overflow: "hidden", maxHeight: maxHeightGal + "px" }}
          >
            <Gallery
              images={images}
              enableImageSelection={false}
              rowHeight={400}
              onClick={(index) => {
                setSelectedVideo(videos[index].id);
              }}
            />
          </div>
          {!hideShowMore && (
            <button onClick={() => onClickShowMore()}>{t("show_more")}</button>
          )}
        </section>
        <VideoModal
          videoId={selectedVideo}
          isOpen={!!selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />
        <section className="contact" id="contact">
          <div className="text-photo-title">{t("contact_us")}</div>
          <div className="contact-form">
            <div className="w50p">
              <div className="text-center">
                {t("first_name")} <span className="req">*</span>
              </div>
              <input
                value={form.firstName}
                onChange={(e) =>
                  setForm({ ...form, firstName: e.target.value })
                }
              />
            </div>
            <div className="w50p">
              <div className="text-center">
                {t("last_name")} <span className="req">*</span>
              </div>
              <input
                value={form.lastName}
                onChange={(e) => setForm({ ...form, lastName: e.target.value })}
              />
            </div>
            <div className="w50p">
              <div className="text-center">{t("phone")}</div>
              <input
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
            </div>
            <div className="w50p">
              <div className="text-center">
                {t("email")} <span className="req">*</span>
              </div>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <div className="w100p">
              <div className="text-center">
                {t("message")} <span className="req">*</span>
              </div>
              <textarea
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
              />
            </div>
            <button onClick={() => onClickSubmit()}>{t("send")}</button>
          </div>
        </section>
        <ToastContainer />
        <Footer />
      </div>
    </I18nextProvider>
  );
}

export default App;
